// extracted by mini-css-extract-plugin
module.exports = {"container":"Layout_container__2g3W4","textContainer":"Layout_textContainer__OKL4V","clickAble":"Layout_clickAble__1h4Ty"};